<template lang="pug">
.kami-charge
  .kami-charge-dialog
    .kami-charge-header
      .kami-charge-person-info(:class='{ vip }')
        img.kami-charge-avatar(:src='avatar')
        div(style='margin-left: 8px')
          .kami-charge-name.f14.white {{ name }}
          .kami-charge-level.f12.white {{ vip ? '已升级' : '未升级' }}
      .f18.white 升级账号，畅享所有功能特权
      .kami-charge-header-side
        img.kami-charge-close(
          src='/static/images/view_btn_close_white.png',
          @click='handleClose'
        )
    .kami-charge-body(v-if='successFlag', style='padding: 25px 12px 30px')
      success(@close='handleClose')
    .kami-charge-body(v-else-if='paymentStatus')
      .kami-charge-success
        .kami-charge-success-top
          img(src='/static/images/success-dj.png')
          .f18.grey3(style='margin-top: 15px') 升级成功
          //- .f16.grey9(style='margin-top: 10px') 你已成功购买
          //-   span(v-if='selectedCostIdx > -1') {{ costList[selectedCostIdx].time }} VIP 会员
          //-   span(v-for='(item, index) in selectHeadsetList', :key='index + 1') {{ index !== 0 || selectedCostIdx > -1 ? '、' : '' }}{{ item.aliasName }}
        div(style='width: 600px; margin: 25px auto 23px; border-top: 1px solid #eee')
        //- div.f18.grey9 {{ backCountdown }}s后返回
        receivingInformation(
          v-if='selectHeadsetList.length',
          @success='successFlag = true',
          :orderNo='orderNo'
        )
        .flex.kami-charge-success-bottom
          div(style='width: 192px; margin-right: 40px')
            p.grey9.fb 欢迎加入我们
            p.grey9(style='margin: 10px 0') 为了向您提供更好的服务，请添加企业微信客服：
          img(src='/static/images/stu/vip/qrcode.png', width='118')
    .kami-charge-body(v-else)
      template(v-if='!boxLoading')
        template(v-if='showCost')
          .activation-method-title 请选择升级方式：
          ul.kami-charge-activation-method
            li(
              v-for='(item, index) in methods',
              :key='index',
              :class='{ active: activationType === item.type }',
              @click='activationType = item.type'
            ) {{ item.name }}
          .qrcode-box(
            v-show='activationType === 1',
            ref='qrcode-box',
            style='padding-top: 30px'
          )
            div(ref='qrcodeDom')
            .down-qr-btn(@click='downloadQR')
              i.el-icon-download
              span 下载二维码
            .copy-qr-btn
              span {{ url }}
              span.copy(@click='copyQrUrl') 复制
            .tip-txt 请下载二维码或复制链接分享给家长，完成升级
          div(v-if='activationType === 2', style='padding-top: 30px')
            activation(@success='successHandle')
          div(v-show='activationType === 3', style='padding-bottom: 18px')
            .kami-charge-cost-message.text-fe8828(:class='{ hasMessage: confirm }') {{ confirm }}
            .kami-charge-top.kami-charge-vip-top(
              :class='{ noSwiper: costList.length < 4 }'
            )
              .swiper-container.swiper-container-charge
                .kami-charge-cost-list.swiper-wrapper
                  .kami-charge-cost.swiper-slide(
                    v-for='(cost, idx) in costList',
                    :key='"cost" + idx',
                    :class='{ active: idx === selectedCostIdx, originalPrice: cost.originalPrice }',
                    @click='handleSelectCost(idx)'
                  )
                    .price-info
                      span.f16.text-fe8828(style='margin-right: 4px') ￥
                      span.f22.text-fe8828(style='font-family: condensed') {{ cost.total }}
                      span.f14.grey6(style='margin-left: 6px') / {{ cost.time }}
                    .original-price.f14.grey9(v-if='cost.originalPrice') &ensp;原价：{{ cost.originalPrice }}&ensp;
                    .kami-charge-day-cost.white {{ cost.day }}
                    .kami-charge-cost-brand.white(v-if='cost.brand') {{ cost.brand }}
              .swiper-button-prev.iconfont(v-if='costList.length > 3') &#xe638;
              .swiper-button-next.iconfont(v-if='costList.length > 3') &#xe638;

            .kami-charge-top.kmai-charge-headset-top(v-if='headsetList.length')
              .headset-title
                h5 学习用品热门推荐
                span 驰声帮你低价团购，赶快看看吧~
              .swiper-container.swiper-container-charge-headset
                .kami-charge-cost-list.swiper-wrapper(
                  :class='{ noSwiper: headsetList.length < 3 }'
                )
                  .kami-charge-cost.kami-charge-headset.swiper-slide(
                    v-for='(cost, idx) in headsetList',
                    :key='"cost" + idx',
                    :class='{ active: cost.isSelect, originalPrice: cost.originalPrice }',
                    @click='handleSelectHeadlist(cost)'
                  )
                    img.defaultImageUrl(:src='cost.defaultImageUrl')
                    .headset-info
                      div(style='margin-top: 16px')
                        span.f14.grey3.font-weight-bold(style='margin-right: 5px') {{ cost.aliasName }}
                        span.headset-tag {{ cost.tag }}
                      span.f22.text-fe8828(style='font-family: condensed') {{ cost.total }}
                      .original-price.f12.grey9(
                        v-if='cost.originalPrice',
                        style='margin-top: 14px'
                      ) &ensp;原价：{{ cost.originalPrice }}&ensp;
                      div(style='margin-top: 8px')
                        span.f12.grey3.font-weight-bold(style='margin-right: 5px') 补贴价
                        span.f16.text-fe8828 ￥
                        span.f22.text-fe8828(style='font-family: condensed') {{ cost.productPrice }}
                    span.detail-button.f12.grey9(
                      @click.slef.stop='todetail(cost.productId)'
                    ) 商品详情 >
                .swiper-button-prev.swiper-button-headset-prev.iconfont(
                  v-if='headsetList.length > 2'
                ) &#xe638;
                .swiper-button-next.swiper-button-headset-next.iconfont(
                  v-if='headsetList.length > 2'
                ) &#xe638;
            .kami-charge-bottom
              .empty-product(v-if='!hasProduct')
                img(src='/static/images/ui/charge/cra.png')
                span 请选择有效期套餐或商品~
              template(v-else)
                .order-info
                  h5 订单信息
                  ul
                    li(v-if='selectedCostIdx > -1') {{ costList[selectedCostIdx].time }} 有效期
                    li(v-for='(item, index) in selectHeadsetList', :key='index + 1') {{ item.aliasName }}
                .flex-start-center
                  .qrcode
                    img(
                      :src='QRCode',
                      :style='{ visibility: QRCode ? "visible" : "hidden" }'
                    )
                    .kami-charge-payment-type.kami-charge-payment-weixin
                    .qrcode-cover.overtime(v-if='overtime', @click='fetchQRCode')
                    .qrcode-cover.loading(v-if='loading')
                      img(src='/static/images/ui/charge/loading.png')
                  div
                    .f12.grey3(
                      style='padding-left: 3px; margin-top: 10px; margin-bottom: 20px'
                    ) 请确认订单信息及金额，使用微信扫码支付
                    span.f24.text-fe8828 ￥
                    span.f36.text-fe8828(style='font-family: condensed') {{ total }}
                    .flex-start-center(style='margin-top: 6px')
                      span.f12.grey9 扫码支付即同意
                      label.f12.green(style='cursor: pointer', @click='go2payment') 《{{ pname }}用户付费协议》
        activation(
          v-else,
          @success='successHandle',
          :showVipIntro='true',
          style='padding-top: 28px'
        ) 
</template>

<script>
/**
 * VIP付费组件
 */
import receivingInformation from '@/components/Stu/receivingInformation/information'
import success from '@/components/Stu/receivingInformation/success'
import {
  studentInfo,
  getProductListV5,
  getPayment,
  checkPay,
  getSetting,
} from '@/api/index'
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import activation from './activation'
import QRCode from 'qrcodejs2'
import copy from '@/util/copy.js'

export default {
  name: 'KamiCharge',
  props: {
    name: {
      type: String,
      default() {
        return this.$store.state.student.name
      },
    },
    avatar: {
      type: String,
      default() {
        return this.$store.state.student.avatar
      },
    },
  },
  components: { receivingInformation, success, activation },
  watch: {
    activationType(v) {
      if (this.costList.length > 3) {
        this.$nextTick(() => {
          this.swiperContainer()
        })
      }
      if (this.headsetList.length > 2) {
        this.$nextTick(() => {
          this.swiperHeadsetContainer()
        })
      }
    },
  },
  data() {
    return {
      boxLoading: true,
      showCost: false,
      url: `${localStorage.getItem(
        'pcpUrl'
      )}/m/vip/index.html?studentId=${localStorage.getItem(
        'studentId'
      )}&cpUrl=${localStorage.getItem('cpUrl')}&from=web`,
      successFlag: false,
      pname: window.ConfigNew.header.name,
      vip: false,
      overtime: false, // 二维码过期
      loading: true, // 读取二维码
      payInfo: {
        // jdcpIP: localStorage.getItem('cpUrl'),
        student_id: this.$store.state.student.id,
        student_name: this.$store.state.student.name,
        // price: '1.00',
        from: 'web',
        subject: window.ConfigNew.header.name + 'VIP套餐费用',
        body: '续期VIP',
        product_type: '4',
        channel: 'wx_pub_qr',
      },
      costList: [
        {
          total: '--',
          day: '--',
          time: '--',
          brand: '特惠',
          price: '--',
        },
      ],
      selectedCostIdx: -1, // 当前选中的套餐
      QRCode: '', // 二维码地址
      paymentType: 'wx_pub_qr', // 支付方式
      paymentStatus: false, // 是否已支付
      backCountdown: 3, // 返回倒计时
      confirm: '',
      headsetList: [],
      total: 0,
      selectHeadsetList: [],
      hasProduct: true,
      orderNo: '',
      activationType: '',
      methods: [],
    }
  },
  methods: {
    todetail(productId) {
      window.open(
        `/static/app/productDetails/index.html?from=web&productId=${productId}&zyurl=${localStorage.getItem(
          'zyUrl'
        )}`
      )
    },
    accuracy(c) {
      return (c.toFixed(4) * 10) / 10
    },
    setTotal() {
      let total = 0
      if (this.selectedCostIdx > -1) {
        total = +this.costList[this.selectedCostIdx].total
      }
      this.selectHeadsetList.forEach((element) => {
        total = this.accuracy(+element.productPrice + total)
      })
      this.total = total.toFixed(2)
    },
    go2payment() {
      window.open('/payment', window.ConfigNew.header.title)
    },
    swiperContainer() {
      if (!this.swiper) {
        this.swiper = new Swiper('.swiper-container-charge', {
          slidesPerView: 3,
          spaceBetween: 16,
          navigation: {
            nextEl: '.kami-charge-vip-top .swiper-button-next',
            prevEl: '.kami-charge-vip-top .swiper-button-prev',
          },
          // centeredSlides: true,
          // autoplay: 5000,
          // loop: true
        })
      }
    },
    swiperHeadsetContainer() {
      if (!this.swiper2) {
        this.swiper2 = new Swiper('.swiper-container-charge-headset', {
          slidesPerView: 2,
          spaceBetween: 16,
          navigation: {
            nextEl: '.kmai-charge-headset-top .swiper-button-next',
            prevEl: '.kmai-charge-headset-top .swiper-button-prev',
          },
          // centeredSlides: true,
          // autoplay: 5000,
          // loop: true
        })
      }
    },
    setPaymentInfo(data, refresh) {
      const { payInfo, orderNo } = data
      this.QRCode = payInfo.code_url
      this.orderNo = orderNo

      if (refresh) {
        clearTimeout(this.timeout)
        this.overtime = false
        this.timeout = setTimeout(() => {
          // 二维码过期时间20分钟
          this.overtime = true
        }, 20 * 60 * 1000)
        this.checkPaymentStatus()
      }
    },
    fetchQRCode() {
      const { costList, selectedCostIdx } = this
      let cost
      if (selectedCostIdx > -1) {
        cost = costList[selectedCostIdx]
      }
      const payInfo = this.payInfo
      payInfo.productIds = [
        ...(cost ? [cost.id] : []),
        ...this.selectHeadsetList.map((i) => i.productId),
      ]
      this.hasProduct = payInfo.productIds.length > 0
      if (!this.hasProduct) return
      // payInfo.price = cost.total
      payInfo.channel = this.paymentType

      this.loading = true
      this.confirm = ''
      getPayment(payInfo, (res) => {
        if (res.status === 1) {
          // const payInfo = res.data
          this.confirm = res.data.confirm
          this.setPaymentInfo(res.data, true)
          this.$nextTick(() => {
            this.loading = false
          })
        } else {
          this.confirm = res.info
        }
      })
    },
    checkPaymentStatus() {
      if (this.orderNo) {
        this.checkPaymentStatusXHR &&
          typeof this.checkPaymentStatusXHR.cancel === 'function' &&
          this.checkPaymentStatusXHR.cancel()

        this.checkPaymentStatusXHR = checkPay(
          {
            jdcpIP: window.ConfigNew.jdcpIP,
            order_no: this.orderNo,
          },
          (res) => {
            if (res.status === 1) {
              const payment_status = res.data.payment_status
              if (payment_status) {
                studentInfo((res) => {
                  // 获取最新的VIP状态
                  if (res.status === 1) {
                    const vipInfo = JSON.parse(this.fn(res.data))
                    this.$store.commit('setVipInfo', vipInfo.vip)
                    // 去掉权限
                    this.$store.commit('setPermission', null)
                    this.paymentStatus = true
                    // this.backInterval = setInterval(() => {
                    //   if (this.backCountdown === 1) {
                    //     this.handleClose()
                    //   } else {
                    //     this.backCountdown -= 1
                    //   }
                    // }, 1000)
                  } else {
                    this.requestFail(res)
                  }
                })
              } else {
                if (!this.overtime) {
                  // 1秒检查1次支付状态，不过现在接口平均要2.5秒返回，也就是3.5秒左右检查一次支付状态
                  clearTimeout(this.checkPaymentTimeout)
                  this.checkPaymentTimeout = setTimeout(this.checkPaymentStatus, 1000)
                }
              }
            } else this.requestFail(res)
          }
        )
      }
    },
    fn(string) {
      const $key = this.$Utf8.parse('zMWFUBwzvUWJVxHWplatform')
      const $iv = this.$Utf8.parse('4563262494851526')
      // 默认cbc Pkcs7
      return this.$AES
        .decrypt(string, $key, {
          iv: $iv,
        })
        .toString(this.$Utf8)
    },
    handleSelectCost(idx) {
      this.selectedCostIdx = this.selectedCostIdx === idx ? '-1' : idx
      this.setTotal()
      this.fetchQRCode()
    },
    handleSelectHeadlist(ele) {
      ele.isSelect = !ele.isSelect
      this.selectHeadsetList = this.headsetList.filter((i) => i.isSelect)
      this.setTotal()
      this.fetchQRCode()
    },
    handleSelectPaymentType(paymentType) {
      this.paymentType = paymentType
      this.fetchQRCode()
    },
    handleToggleConfirm() {
      this.confirm = !this.confirm
    },
    handleClose() {
      clearInterval(this.backInterval)
      this.$store.commit('toggleChargeModel')
      var pathArr = this.$route.path.split('/')
      if (
        pathArr[pathArr.length - 1] === 'StuAggregateMain' ||
        pathArr[pathArr.length - 1] === 'StuCollectionMain'
      ) {
        this.$router.push({ name: 'stuIndex' })
        document.body.style.overflow = ''
      }
    },
    successHandle() {
      studentInfo((res) => {
        // 获取最新的VIP状态
        if (res.status === 1) {
          const vipInfo = JSON.parse(this.fn(res.data))
          this.$store.commit('setVipInfo', vipInfo.vip)
          // 去掉权限
          this.$store.commit('setPermission', null)
          this.paymentStatus = true
          clearTimeout(this.timeout)
          clearTimeout(this.checkVipTimeout)
        }
      })
    },
    downloadQR() {
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = this.$refs['qrcode-box'].querySelector('img').src
      link.setAttribute('download', '找家升级二维码')
      document.body.appendChild(link)
      this.downFlag = false
      link.click()
      link.remove()
    },
    copyQrUrl() {
      if (this.$store.state.vipUntilGraduation) {
        return this.$toast({
          text: '您的VIP有效期很充足，暂不支持续期。',
          showWrap: false,
          iconFlag: false,
          duration: 1000,
          styleObj: {
            width: '300px',
            height: '50px',
            'border-radius': '4px',
            'background-color': 'rgba(0, 0, 0, 0.6)',
          },
        })
      }
      copy(this.url).then(() => {
        this.$toast({
          text: '复制成功',
          showWrap: false,
          iconFlag: false,
          duration: 1000,
          styleObj: {
            width: '140px',
            height: '50px',
            'border-radius': '4px',
            'background-color': 'rgba(0, 0, 0, 0.6)',
          },
        })
      })
    },
    checkVip() {
      this.checkVipTimeout = setTimeout(() => {
        studentInfo((res) => {
          // 获取最新的VIP状态
          if (res.status === 1) {
            const vipInfo = JSON.parse(this.fn(res.data))
            if (
              vipInfo.vip.vipDays > this.$store.state.student.vipdays &&
              !vipInfo.vip.isExpired
            ) {
              this.$store.commit('setVipInfo', vipInfo.vip)
              // 去掉权限
              this.$store.commit('setPermission', null)
              this.paymentStatus = true
              clearTimeout(this.timeout)
              clearTimeout(this.checkVipTimeout)
            } else {
              this.checkVip()
            }
          }
        })
      }, 2000)
    },
  },
  created() {
    const types = {
      1: {
        type: 1,
        name: '找家长升级',
      },
      2: {
        type: 2,
        name: '激活卡',
      },
      3: {
        type: 3,
        name: '在线激活',
      },
    }
    getSetting().then((res) => {
      if (res.status === 1) {
        this.showCost = !(
          res.data.SHOW_BTNS.length === 1 && res.data.SHOW_BTNS.includes(2)
        )
      }

      this.methods = res.data.SHOW_BTNS.map(i => {
        return types[i]
      })
      this.boxLoading = false
      this.vip = this.$store.state.isRealVip
      this.activationType = res.data.SHOW_BTNS[0]
      if (this.showCost) {
        this.$nextTick(() => {
          this.qr = new QRCode(this.$refs.qrcodeDom, {
            text: this.url, // 扫码后页面地址
            width: 180, // 二维码宽度
            height: 180, // 二维码高度
            colorDark: '#000000', // 二维码颜色
            colorLight: '#ffffff', // 背景颜色
            correctLevel: QRCode.CorrectLevel.H, // 校正水准
          })
        })
        getProductListV5((res) => {
          if (res.status === 1) {
            // 20201208 庄主要求注释 为了排序
            // res.data.sort((x, y) => {
            //   return y.productPrice - x.productPrice
            // })

            this.costList = res.data.vip.map((product, index) => {
              return {
                id: product.productId,
                total: product.productPrice,
                time: product.productName,
                day: product.aliasName,
                brand: product.brand,
                price: Number(product.productPrice),
                originalPrice: product.originalPrice,
              }
            })
            // if (this.costList.length > 3) {
            //   this.$nextTick(() => {
            //     this.swiperContainer()
            //   })
            // }
            this.headsetList = res.data.headset.map((headset, index) => {
              return {
                ...headset,
                isSelect: false,
              }
            })
            // if (this.headsetList.length > 2) {
            //   this.$nextTick(() => {
            //     this.swiperHeadsetContainer()
            //   })
            // }
            this.handleSelectCost(0)
          } else this.requestFail(res)
        })
        this.checkVip()
      }
    })
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
    clearTimeout(this.checkVipTimeout)
    this.overtime = true
    this.checkPaymentStatusXHR &&
      typeof this.checkPaymentStatusXHR.cancel === 'function' &&
      this.checkPaymentStatusXHR.cancel()
  },
}
</script>

<style lang="less" scoped>
@font-face {
  font-family: condensed;
  src: url('/static/fonts/HELVETICANEUE_BLACKCOND.ttf');
}
.price-info {
  display: flex;
  align-items: center;
}
.f22 {
  font-size: 22px;
}
.kami-charge {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 98;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);

  .qrcode {
    position: relative;
    width: 100px;
    // height: 110px;
    margin-right: 18px;
    border: 1px solid #f4f4f4;

    & > img {
      width: 80px;
      height: 80px;
      margin-top: 8px;
      margin-left: 10px;
    }
  }

  .qrcode-cover {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8);
    background-repeat: no-repeat;
    background-position: center;

    &.overtime {
      background-image: url('/static/images/ui/charge/btn_refurbish.png');
      cursor: pointer;
    }

    &.loading {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        animation: rotate 3s linear infinite;
      }
    }
  }

  .icon-confirm {
    width: 16px;
    height: 16px;
    margin-right: 8px;
    background-image: url('/static/images/icon_common.png');
    cursor: pointer;
    &.active {
      background-position-x: -16px;
    }
  }
}
.kami-charge-dialog {
  width: 800px;
  // height: 540px;
  border-radius: 6px;
  background-color: #f4f4f4;
  overflow: hidden;
}
.kami-charge-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
  padding-left: 26px;
  padding-right: 18px;
  background-image: url('/static/images/ui/charge/ic_tankuang_bg.png'),
    linear-gradient(to right, #fe812f, #ffb800);
}
.kami-charge-body {
  // padding: 0 0 18px;
  height: 500px;
  overflow: auto;
  background: #fff;
}
.kami-charge-person-info {
  position: relative;
  display: flex;
  align-items: center;
  &.vip::after {
    content: '';
    position: absolute;
    bottom: 0px;
    left: 26px;
    display: block;
    width: 14px;
    height: 14px;
    background-image: url('/static/images/stu/index/ic_v.png');
    background-size: cover;
  }
}
.kami-charge-avatar {
  width: 40px;
  height: 40px;
  border-radius: 20px;
}
.kami-charge-name {
  line-height: 20px;
}
.kami-charge-level {
  line-height: 16px;
  color: rgba(255, 255, 255, 0.8);
}
.kami-charge-header-side {
  width: 104px;
  text-align: right;
}
.kami-charge-close {
  width: 30px;
  height: 30px;
  cursor: pointer;
}

.kami-charge-top {
  display: flex;
  flex-direction: column;
  // height: 170px;
  padding: 0 30px;
  position: relative;
}
.noSwiper.kami-charge-top {
  padding: 0 0 0 30px;
}
.kami-charge-cost-list {
  display: flex;
  // justify-content: space-between;
  // align-items: center;
}
.kami-charge-cost {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 236px;
  height: 110px;
  padding: 26px 0 22px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background-color: #fff;
  cursor: pointer;
  &.active {
    border: 2px solid #fe8828;
    background-color: #fffbef;
    &::before {
      content: '';
      position: absolute;
      background: url('/static/images/vipdj.png');
      width: 40px;
      height: 36px;
      top: 0;
      right: 0;
    }
    .kami-charge-cost-brand {
      top: -2px;
      left: -2px;
    }
  }
}
.kami-charge-headset {
  width: 362px;
  display: flex;
  flex-direction: row;
  padding: 7px 5px 5px !important;
  justify-content: normal;
}

.noSwiper .kami-charge-cost-list .kami-charge-cost {
  margin-left: 16px;
}
.noSwiper .kami-charge-cost-list .kami-charge-cost:first-child {
  margin-left: 0px;
}
.kami-charge-cost.originalPrice {
  padding: 26px 0 10px;
}
.kami-charge-day-cost {
  width: 100px;
  height: 24px;
  border-radius: 12px;
  font-size: 16px;
  text-align: center;
  line-height: 24px;
  background-color: #fe8828;
}
.kami-charge-cost-brand {
  position: absolute;
  top: -1px;
  left: -1px;
  width: 60px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  background-image: linear-gradient(to right, #f8b60d, #ffce16);
}
.kami-charge-cost-message {
  // flex: 1;
  font-size: 14px;
  line-height: 38px;
  min-height: 38px;
  margin-top: 2px;
  padding: 0 30px;
}
.kami-charge-cost-message.hasMessage::before {
  content: '';
  display: inline-block;
  width: 6px;
  height: 6px;
  margin-right: 4px;
  border-radius: 3px;
  vertical-align: middle;
  background-color: #fe8828;
}

.kami-charge-bottom {
  display: flex;
  align-items: center;
  width: 740px;
  // padding: 20px 0 16px;
  margin: 0 auto;
  border: 1px solid #e0e0e0;
  background-color: #fff;
  margin-top: 15px;
}
.kami-charge-scan {
  width: 18px;
  height: 18px;
  margin-right: 8px;
  background-image: url('/static/images/stu/ic_saoma.png');
}
.kami-charge-payment-type {
  width: 100px;
  height: 30px;
}
.kami-charge-payment-zhifubao {
  background-image: url('/static/images/stu/btn_alipay_normal.png');
  &.active {
    background-image: url('/static/images/stu/btn_alipay_active.png');
  }
}
.kami-charge-payment-weixin {
  // background-image: url("/static/images/stu/btn_wechat_normal.png");
  background-image: url('/static/images/ui/charge/ic_wechat.png');
  &.active {
    background-image: url('/static/images/stu/btn_wechat_active.png');
  }
  width: 74px;
  height: 24px;
  background-size: contain;
  margin-left: 13px;
}

.kami-charge-success {
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
  align-items: center;
  width: 740px;
  // height: 424px;
  padding: 40px 0 78px;
  margin: 0 auto;
  border: 1px solid #e0e0e0;
  background-color: #fff;

  &-top {
    img {
      display: block;
      margin: 0 auto;
    }

    .grey3 {
      text-align: center;
      line-height: 30px;
      font-weight: bold;
    }
    .grey9 span {
      color: #fe8828;
      font-size: 16px;
      font-weight: bold;
    }
  }

  &-bottom {
    .grey9 {
      line-height: 20px;
    }
  }
}
.swiper-container-charge,
.swiper-container-charge-headset {
  width: 100%;
}
.swiper-button-prev,
.swiper-button-headset-prev {
  text-align: center;
  font-size: 22px;
  left: -8px;
  top: 66px;
  background-image: none !important;
  transform: rotate(90deg);
  outline: none;
}
.swiper-button-next,
.swiper-button-headset-next {
  text-align: center;
  right: -8px;
  top: 66px;
  outline: none;
  font-size: 22px;
  background-image: none !important;
  transform: rotate(-90deg);
}
.swiper-button-headset-prev,
.swiper-button-headset-next {
  top: 116px;
}
.original-price {
  text-decoration: line-through;
}

@keyframes rotate {
  from {
    transform: rotateZ(0);
  }

  to {
    transform: rotateZ(360deg);
  }
}

.headset-title {
  display: flex;
  align-items: center;
  margin: 22px 0 15px;
  h5 {
    height: 16px;
    font-size: 16px;
    font-weight: bold;
    color: #333;
    line-height: 16px;
  }
  span {
    height: 14px;
    font-size: 14px;
    color: #999;
    line-height: 16px;
    margin-left: 10px;
  }
}
.defaultImageUrl {
  width: 86px;
  height: 98px;
}
.order-info {
  border-right: 1px solid #e0e0e0;
  width: 327px;
  height: 138px;
  padding: 20px 18px;
  margin-right: 22px;
  h5 {
    width: 64px;
    height: 16px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    line-height: 16px;
  }
  ul {
    margin-top: 16px;
    overflow: auto;
    height: 74px;
    li {
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 24px;
      &::before {
        content: '';
        display: inline-block;
        width: 6px;
        height: 6px;
        background: #5d5d5d;
        border-radius: 50%;
        margin-right: 7px;
      }
    }
  }
}
.headset-info {
  margin-left: 4px;
  position: relative;
}
.headset-tag {
  height: 18px;
  background: #fe8828;
  padding: 0 7px;
  font-size: 12px;
  color: #fffbef;
  line-height: 18px;
}
.detail-button {
  position: absolute;
  bottom: 16px;
  right: 14px;
  cursor: pointer;
}
.detail-button:hover {
  color: #fe8828;
}
.empty-product {
  height: 140px;
  width: 100%;
  img {
    display: block;
    margin: 28px auto 0;
  }
  span {
    display: block;
    text-align: center;
    font-size: 12px;
    color: #999999;
    margin-top: 20px;
  }
}
.activation-method-title {
  font-size: 16px;
  color: #666666;
  line-height: 21px;
  padding: 30px 30px 0;
}
.kami-charge-activation-method {
  display: flex;
  margin: 10px 30px 0px;
  padding-bottom: 30px;
  border-bottom: 1px solid #e5e5e5;
  li {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 140px;
    height: 46px;
    background: #fff3df;
    border-radius: 6px;
    border: 1px solid #ffbd7b;
    margin-right: 30px;
    font-size: 14px;
    color: #ff7e00;
    cursor: pointer;
    &.active {
      background: #ff7e00;
      color: #ffffff;
    }
  }
}
.qrcode-box {
  display: flex;
  align-items: center;
  flex-direction: column;
  .down-qr-btn {
    width: 180px;
    height: 30px;
    background: #ff7e00;
    border-radius: 6px;
    text-align: center;
    margin-top: 10px;
    cursor: pointer;
    i {
      font-size: 14px;
      color: #ffffff;
      line-height: 30px;
    }
    span {
      font-size: 14px;
      color: #ffffff;
      line-height: 30px;
      margin-left: 10px;
    }
  }
  .copy-qr-btn {
    width: 180px;
    height: 30px;
    background: #fff3df;
    border-radius: 6px;
    border: 1px solid #ffbd7b;
    margin-top: 10px;
    display: flex;
    span {
      font-size: 12px;
      color: #666666;
      line-height: 28px;
      padding: 0 6px;
      overflow: hidden;
      flex: 1;
    }
    .copy {
      width: 40px;
      flex: inherit;
      background: #ff7e00;
      font-size: 14px;
      color: #ffffff;
      cursor: pointer;
    }
  }
  .tip-txt {
    margin-top: 10px;
    font-size: 12px;
    font-weight: 400;
    color: #666666;
    line-height: 17px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/UIO/Charge.vue